// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.tr_one_line[data-v-a186b676] {\n  height: 80px;\n}\n.alert_color[data-v-a186b676] {\n  color: #ff6565;\n}\n.success_color[data-v-a186b676] {\n  color: #3b86ff;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
